import React from "react";
import { Layers, Hammer, AppWindow, DoorOpen, PaintRoller, Brush, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Drywall Installation",
  description: "Precision hanging, finishing, and seamless repairs for flawless interior wall surfaces.",
  icon: Layers
}, {
  title: "Interior & Exterior Painting",
  description: "Expert color application using premium coatings for durable and aesthetic finishes.",
  icon: PaintRoller
}, {
  title: "Pressure Cleaning",
  description: "High-power restoration for driveways, siding, and decks to remove deep-seated grime.",
  icon: Brush
}, {
  title: "Project Management",
  description: "End-to-end oversight ensuring your construction projects meet deadlines and quality standards.",
  icon: Hammer
}, {
  title: "Plumbing Fixtures",
  description: "Professional installation of high-end toilets, vanities, and faucets with precision sealing.",
  icon: AppWindow
}, {
  title: "Residential Demo & Hauling",
  description: "Safe interior demolition and efficient debris removal to clear your space for renovation.",
  icon: DoorOpen
}];
export default function ExteriorMastery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="4287" id="specialized-services" className="dark bg-background text-foreground py-20 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={ref} className={`flex items-center gap-6 mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="w-1.5 h-16 bg-primary shrink-0 rounded-sm" />
          <div>
            <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tighter uppercase text-foreground">
              Specialized Services
            </h2>
            <p className="text-muted-foreground mt-2 text-lg max-w-2xl font-sans">
              Precision construction and maintenance solutions provided by Smith & B Group LLC.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                <Card className="h-full bg-card border-border hover:border-primary transition-colors duration-300 flex flex-col justify-between group rounded-sm shadow-none">
                  <CardHeader className="pb-2">
                    <div className="mb-6">
                      <Icon className="w-10 h-10 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-2xl font-default font-bold leading-tight tracking-tight">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pb-6">
                    <p className="text-muted-foreground line-clamp-2 font-sans">
                      {service.description}
                    </p>
                  </CardContent>
                  <CardFooter>
                    <Link to="#" className="group/link inline-flex items-center text-primary font-mono font-semibold text-xs uppercase tracking-widest hover:text-primary/80 transition-colors">
                      Learn More
                      <ArrowRight className="ml-2 h-3 w-3 transition-transform duration-300 group-hover/link:translate-x-1.5" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}